export default __webpack_public_path__ + "static/media/closeChat.8c8340a2.svg";